import { useState } from "react";
import DatePicker from "react-date-picker";
import { CustomDate_Svg } from "../../resources/assetsManager";
import {
  BLACK_COLOR,
  LIGHT_GREY_BG_MODAL,
} from "../../resources/colorsManager";
import "./index.css";

const dateConvertor = (date, dateOutputFormat = false) => {
  const newData = new Date(date);
  let year = newData.getFullYear();
  let month = newData.getMonth();
  let day = newData.getDate();
  console.log("dateOutputFormat", dateOutputFormat);
  if (dateOutputFormat === "DD-MM-YYYY") {
    return `${day}/${month}/${year}`;
  } else {
    return `${year}/${month}/${day}`;
  }
};

const dateConvertor1 = (date) => {
  const newData = new Date(date);
  let year = newData.getFullYear();
  let month = newData.getMonth() + 1;
  let day = newData.getDate();
  return `${day}/${month}/${year}`;
};
function DatePickerNew({
  onChangeData,
  datePlaceholder = "Date",
  style,
  minDate,
  fontStyles,
}) {
  const [value, onChange] = useState("");

  const inputStyle = {
    backgroundColor: LIGHT_GREY_BG_MODAL,
    alignSelf: "center",
    flex: 1,
    marginBottom: 15,
    height: 45,
    width: "100%",
    boxShadow: "none",
    borderRadius: 5,
  };

  return (
    <div
      style={{
        ...inputStyle,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 10px 0px 10px",
        ...style,
        width: "100%",
      }}
    >
      <p
        style={{
          fontSize: 14,
          color: BLACK_COLOR,
          ...fontStyles,
          whiteSpace: "nowrap",
        }}
      >
        {value.toString() ? dateConvertor1(value.toString()) : datePlaceholder}
      </p>
      <DatePicker
        onChange={(data) => {
          if (data) {
            onChange(data);
            onChangeData(dateConvertor1(data.toString()));
          }
        }}
        value={value}
        calendarIcon={
          <img
            src={CustomDate_Svg}
            style={{
              width: 20,
              height: 20,
              color: "dodgerblue",
            }}
          />
        }
        monthPlaceholder=""
        yearPlaceholder=""
        dayPlaceholder=""
        clearIcon={false}
        style={{
          width: 300,
        }}
        placeholderText="Please select a date"
        minDate={minDate ? minDate : ""}
      />
    </div>
  );
}

export default DatePickerNew;
